import { render } from "./StoryCommentThread.vue.js?vue&type=template&id=3241b3d2!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentThread.vue?vue&type=template&id=3241b3d2"
import script from "./StoryCommentThread.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentThread.vue?vue&type=script&lang=js"
export * from "./StoryCommentThread.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentThread.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/components/story-comments/StoryCommentThread.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3241b3d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3241b3d2', __exports__)) {
    api.reload('3241b3d2', __exports__)
  }
  
  module.hot.accept("./StoryCommentThread.vue.js?vue&type=template&id=3241b3d2!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentThread.vue?vue&type=template&id=3241b3d2", () => {
    api.rerender('3241b3d2', render)
  })

}


export default __exports__